/**
 * 가치 평가 API — /v1/valuation/*
 */
import { apiClient } from "./client";

/** GET /v1/valuation/dcf 단일 종목 결과 (services/dcf_valuation_service.py) */
export interface DcfResult {
  stock_id: string;
  applicable: boolean;
  reason: string | null;
  assumptions: {
    discount_rate: number;
    terminal_growth: number;
    stage1_years: number;
    method: string;
  };
  fcf_history: { year: string; ocf: number; capex: number; fcf: number }[];
  fcf_base: number | null;
  growth_stage1: number | null;
  net_debt: number | null;
  total_debt: number | null;
  cash: number | null;
  shares_outstanding: number | null;
  current_price: number | null;
  intrinsic_value: number | null;
  safety_margin_pct: number | null;
  warning: string | null;
  sector: string | null;
  alternative: { pbr: number | null; dividend_yield_pct: number | null; per: number | null } | null;
  kis_reference: { eps?: number; per?: number; eps_date?: string };
}

/** GET /v1/valuation/dcf?stock_ids= — 쉼표 구분 복수 종목 (재무 데이터 일 1회 캐시) */
export const valuationApi = {
  getDcf: (stockIds: string[]) =>
    apiClient
      .get<{ results: Record<string, DcfResult> }>(`/v1/valuation/dcf`, {
        stock_ids: stockIds.join(","),
      })
      .then((res) => res.results),
};
